export const SITE_CREATION_DIALOG_TITLE = 'site-creation-dialog.title';
export const SITE_CREATION_DIALOG_DESCRIPTION = 'site-creation-dialog.description';
export const SITE_CREATION_DIALOG_BUTTON_TEXT = 'site-creation-dialog.button-text';
export const SITE_CREATION_DIALOG_ICON_ALT = 'site-creation-dialog.icon-alt';
